module.exports = "/img/user-guided-tours/tags-usage/or@2x.png?69aa96893b8b93ff4369ecd25c5f5d73";